import { createTheme } from "@mui/material/styles";
// Theme colors based on the logo
export const themeColors = {
    primary: "#41C8C4", // Teal/turquoise from logo
    secondary: "#000000", // Black from logo
    background: "#121212", // Dark background
    paper: "#1E1E1E", // Slightly lighter dark for cards/surfaces
    text: "#FFFFFF", // White for primary text
    textSecondary: "#B0B0B0", // Light gray for secondary text
    accent: "#2A2A2A", // Dark gray for accents
};
// Create MUI theme with logo colors
const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: themeColors.primary,
            contrastText: "#000000",
        },
        secondary: {
            main: themeColors.secondary,
            contrastText: "#FFFFFF",
        },
        background: {
            default: themeColors.background,
            paper: themeColors.paper,
        },
        text: {
            primary: themeColors.text,
            secondary: themeColors.textSecondary,
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 500,
            color: themeColors.text,
        },
        h2: {
            fontWeight: 500,
            color: themeColors.primary,
        },
        button: {
            textTransform: "none",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    padding: "8px 16px",
                },
                contained: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    marginBottom: 16,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: 8,
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                ".MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                },
            },
        },
    },
});
export default theme;
